import { Modal, notification, Text } from "components/common"
import { useTranslation } from "react-i18next"
import { useRemoveFromAuditConcernMutation } from "features/leads/api"

export default function WatchListForm({ lead, formRef }) {
  const { t } = useTranslation()
  const [removeFromWatchlist, { isLoading: isRemoving }] = useRemoveFromAuditConcernMutation()
  const handleSubmit = async () => {
    try {
      let response
      response = await removeFromWatchlist(lead?.id).unwrap()
      notification.success({ message: t("Audit Concern Removed Successfully") })
      formRef.current?.setVisible(false)
    } catch (error) {
      notification.error({ message: error?.message })
    }
  }
  return (
    <Modal
      ref={formRef}
      okText={t("Remove")}
      cancelText={t("Cancel")}
      title={t("Remove from Audit Concern")}
      width={500}
      destroyOnClose
      onCancel={() => formRef.current?.setVisible(false)}
      onOk={handleSubmit}
      loading={isRemoving}
    >
      <Text>{t("Are you sure you want to remove this lead from the Audit Concern?")}</Text>
    </Modal>
  )
}
